import { Tabs } from "src/components";

export interface PageContainerProps {
  header?: React.ReactNode;
  tabList?: { key: string; tab: React.ReactNode }[];
  children?: React.ReactNode;
  tabActiveKey?: string;
  onTabChange?: (activeKey: string) => void;
}

function PageContainer(props: PageContainerProps) {
  return (
    <>
      {props.header}
      {props.tabList?.length && (
        <Tabs activeKey={props.tabActiveKey} onChange={props.onTabChange}>
          {props.tabList.map((tabProps) => (
            <Tabs.TabPane {...tabProps} />
          ))}
        </Tabs>
      )}
      {/* Padding drops to 12 on phones (AuthenticatedLayout.scss). */}
      <div className="page-container-body" style={{ backgroundColor: "white", borderRadius: "8px" }}>
        {props.children}
      </div>
    </>
  );
}

export default PageContainer;
